import axios from "axios";
import { toast } from "sonner";
import { removeItemFromLocalStorage } from "~/lib/helperFuncation/localStorageService";
import { setIsUserLoginFalse } from "~/lib/store/slice/loginSlice";
import { API_BASE_URL, AUTH_COOKIE_TOKEN, USER_COUNTRY_PHONE_CODE, USER_MOBILE_NUMBER } from "./constant";
import { deleteCookie } from "./cookies";

let latestOtpToken: string | null = null;

const smkInstance = axios.create({ baseURL: API_BASE_URL });

// Response Interceptor
smkInstance.interceptors.response.use(
  (response) => {
    const newOtpToken = response?.data?.data?.otp_token || response?.data?.data?.passwordToken;
    if (newOtpToken) {
      latestOtpToken = newOtpToken;
    }

    return response;
  },
  (error) => {
    console.error("API Error:", error?.response?.data || error.message);

    if (error.response.data.status == 307) {
      latestOtpToken = error.response.data.data.passwordToken;
    }

    if (error?.response?.status === 401) {
      deleteCookie(AUTH_COOKIE_TOKEN);
      removeItemFromLocalStorage(USER_COUNTRY_PHONE_CODE);
      removeItemFromLocalStorage(USER_MOBILE_NUMBER);

      if (storeDispatch) {
        storeDispatch(setIsUserLoginFalse());
      }

      // Redirect to home page
      toast.error(error?.response?.data?.message || "Session expired. Please log in again.");
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

// Request Interceptor
smkInstance.interceptors.request.use((config) => {
  if (config.headers) {
    config.headers["Content-Type"] = "application/json";
    if (latestOtpToken) {
      config.headers["Authorization"] = `Bearer ${latestOtpToken}`;
    }
  }

  return config;
});

// Exposed Functions
export const setLatestOtpToken = (token: string) => {
  latestOtpToken = token;
};

export const getLatestOtpToken = () => latestOtpToken;

// Function to set store dispatch function
let storeDispatch: ((action: any) => void) | null = null;

export const setStoreDispatch = (dispatch: (action: any) => void) => {
  storeDispatch = dispatch;
};

export const createSmkApi = () => smkInstance;
